import type { MutableRefObject } from "react";
import { useRef } from "react";

import { useTrustPilot } from "@ui/hooks/useTrustPilot";

import { useConfig } from "@jti/app-context/useConfig";

type TemplateIdKey =
  | "microComboWidgetTemplateId"
  | "microReviewCountWidgetTemplateId"
  | "reviewsWidgetTemplateId"
  | "starsWidgetTemplateId";

type UseTrustPilotWidgetOptions = {
  width?: string;
  height?: string;
  theme?: string;
};

export const useTrustPilotConfig = (templateIdKey: TemplateIdKey, options: UseTrustPilotWidgetOptions = {}) => {
  const config = useConfig();
  const ref = useRef<HTMLDivElement>(null) as MutableRefObject<HTMLDivElement>;
  useTrustPilot({ ref, ...options });

  const templateId = config[templateIdKey];
  const isMisconfigured = !config.localeCode || !config.businessUnitId || !templateId;

  return {
    ref,
    isEnabled: config.isEnabledForTenant && !isMisconfigured,
    localeCode: config.localeCode,
    businessUnitId: config.businessUnitId,
    templateId,
    leaveAReviewLink: config.leaveAReviewLink || "",
    theme: config.theme,
  };
};
